import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./servicedetails.css";
import Companies from "./Companies";
import { detailData } from "./detailData";
import Footer from "./Footer";
import VideoWithImage from "./VideoWithImage";
function ServiceDetails() {
  const slug = useLocation();
  const serviceName = slug.pathname.split("/")[2];
  const navigate = useNavigate();
  const selectedServiceData = detailData.filter(
    (item) => item.slug === serviceName
  );
  const data = selectedServiceData[0];

  return (
    <div className="servidetails-container">
      <section className="video-section">
        <VideoWithImage videoSrc={data.mainVideo} className="video-container" />


        <div
          className="logo-serice"
          onClick={() => navigate("/", { state: { scrollTo: "cards" } })}
        >
          <img className="logo-service-img" src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/logo.png" alt="Equinox" />
        </div>
      </section>

      <section className="about-services-section">
        <h3 className="heading-services">{data.aboutservice}</h3>
        <div className="about-service-container">
          <div className="about-service-left-container">
            <h3 className="service-desc">{data.serviseDesc}</h3>
            <div className="service-about-points">
              <div>
                <ul>
                  {data.aboutPointsleft.map((item, index) => (
                    <li className="about-points" key={index}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <ul>
                  {data.aboutPointsright.map((item, index) => (
                    <li className="about-points" key={index}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="about-service-right-container">
            <VideoWithImage videoSrc={data.videoAbout} className="video-container" />
            {/* <video className="about-video" autoPlay playsInline muted loop>
              <source src={data.videoAbout} />
            </video> */}
          </div>
        </div>
      </section>
      <section className="our-prjcts-section">
        <h3 className="heading-services" style={{ fontWeight: "600" }}>
          {data.previospjct}
        </h3>
        <div className="our-prev-prjct-container">
          <div className="ourpjct-left-container">
            {" "}
            <VideoWithImage videoSrc={data.prvvideo} className="video-container" />
            {/* <video className="about-video" autoPlay playsInline muted loop>
              <source src={data.prvvideo} />
            </video> */}
          </div>
          <div className="ourpjct-right-container">
            <h3 className="prev-heading">{data.prvheading}</h3>
            {data.prevpjctdesc.split("\n").map((line, idx) => (
              <p className="prev-proj-desc" key={idx}>
                {line}
              </p>
            ))}
          </div>
        </div>

        {data.prevpjctcontent.split("\n").map((line, idx) => (
          <p className="prev-prj-content" key={idx}>
            {line}
          </p>
        ))}
      </section>
      <section className="our-demo-projects-container ">
        <div className="our-prev-prjct-container our-demos-container">
          <div className="ourpjct-left-container">
            <VideoWithImage videoSrc={data.productdemovideo} className="video-container" />
            {" "}
            {/* <video className="about-video" autoPlay playsInline muted loop>
              <source src={data.productdemovideo} />
            </video> */}
          </div>
          <div className="ourpjct-right-container">
            <h3 className="pro-demo-heading">{data.proddemoheading}</h3>
            {data.productdemodesc.split("\n").map((line, idx) => (
              <p className="prev-proj-desc" key={idx}>
                {line}
              </p>
            ))}
          </div>
        </div>
        {data.proddemocontent.split("\n").map((line, idx) => (
          <p className="prev-prj-content" key={idx}>
            {line}
          </p>
        ))}
      </section>
      <Companies />
      <Footer />
    </div>
  );
}

export default ServiceDetails;
